import { tokenizer } from '../../services/utils'
import l10n from '../i18n/I18N'
import { closeCXMessenger, isCXmessengerAdded, removeCXMessenger } from './CXMessenger'
import { removeLiveChatWidget } from './LiveChat'

let timeoutId = -1
const scriptTagId = 'ze-snippet'
const addZendeskWidget = (widgetConfig, openCallback, closeCallback, openOnInit) => {
  console.log('[Zendesk] add widget')
  /*
    zendesk config
    key: provided by zendesk, must match desired widget
    widget: The widget must match the key, for the chatbot, use 'messenger'. For e-mail form use 'webWidget'
    src: url to zendesk script src
    */
  const zendeskKey = widgetConfig.key ? widgetConfig.key : process.env.REACT_APP_CASINO_ZENDESK_KEY
  let src = widgetConfig.src ? widgetConfig.src : 'https://static.zdassets.com/ekr/snippet.js?key={zendeskKey}'
  src = tokenizer(src, { '{zendeskKey}': zendeskKey })

  // Once the widget has been added, there is no simple/safe way to remove it and replace with another at runtime
  // Clear any timeout currently in progress to prevent prior call from adding widget
  if (timeoutId != -1) {
    clearTimeout(timeoutId)
  }

  const widget = widgetConfig.widget ? widgetConfig.widget : 'webWidget'
  const snippetId = widgetConfig.snippetId ? widgetConfig.snippetId : ''
  const zendeskScriptTag = document.createElement('script')
  zendeskScriptTag.id = scriptTagId
  zendeskScriptTag.async = true
  zendeskScriptTag.src = src

  // currently not supporting two help widgets
  if (isCXmessengerAdded()) {
    closeCXMessenger()
    removeCXMessenger()
    removeLiveChatWidget()
  }

  const defaultDelay = 2000
  const delay = widget.addDelay ? widget.addDelay : defaultDelay

  const onLoadFunc = () => {
    console.log('[Zendesk] script loaded', timeoutId)

    let settingsJson = {}
    settingsJson[widget] = {
      snippetID: snippetId
    }

    // legacy widget support
    if (widget === 'webWidget') {
      // load, re-load Zendesk chat on locale change. for Zendesk tags that aren't localized properly, set our own
      settingsJson[widget].chat = {
        suppress: true,
        offlineForm: {
          greeting: {
            '*': l10n.t['casino.chatOffline']
          }
        },
        prechatForm: {
          greeting: {
            '*': l10n.t['casino.chatPreChat']
          }
        }
      }
    }

    window.zESettings = settingsJson

    // keep track of the state
    window.zE(widget + ':on', 'open', openCallback)
    window.zE(widget + ':on', 'close', closeCallback)

    showZendeskWidget(true)

    if (openOnInit) {
      setTimeout(() => {
        openZendeskWidget()
      }, delay)
    }
  }

  const addZendeskScriptTag = () => {
    console.log('[Zendesk] timeout complete', timeoutId)
    document.getElementsByTagName('body')[0].appendChild(zendeskScriptTag)
    zendeskScriptTag.addEventListener('load', onLoadFunc)
  }

  if (openOnInit) {
    addZendeskScriptTag()
  } else {
    timeoutId = setTimeout(() => {
      addZendeskScriptTag()
    }, delay)
    console.log('[Zendesk] timeout ', timeoutId, delay)
  }
}

const isZendeskWidgetAdded = () => {
  return document.getElementById(scriptTagId) !== null
}

const removeZendeskWidget = () => {
  console.log('[Zendesk] remove widget', timeoutId)
  // The zend desk widget can not be removed
  // The best we can do is avoid adding it within the delay time else hide it.
  if (timeoutId != -1) {
    console.log('[Zendesk] cleartimeout ', timeoutId)
    clearTimeout(timeoutId)
  }

  showZendeskWidget(false)
}

const zendeskAction = action => {
  if (window.zE && window.zE.widget) {
    try {
      window.zE(window.zE.widget === 'classic' ? 'webWidget' : window.zE.widget, action)
    } catch (e) {
      // do nothing
    }
  }
}

const showZendeskWidget = show => {
  zendeskAction(show ? 'show' : 'hide')
}

const openZendeskWidget = () => {
  zendeskAction('open')
}

const closeZendeskWidget = () => {
  zendeskAction('close')
}

const logoutZendeskUser = () => {
  zendeskAction('logoutUser')
}

export {
  addZendeskWidget,
  openZendeskWidget,
  closeZendeskWidget,
  isZendeskWidgetAdded,
  removeZendeskWidget,
  logoutZendeskUser
}
